import React from "react";
import { Card, Stack, Text } from "@bookingcom/bui-react";
import { IconWithBackground } from "@flights/search-ui";
import { FlightDetailsSectionTitleMobileUI } from "./FlightDetailsSectionTitle.mobile.ui.js";
import { StarUpIcon } from "@bookingcom/bui-assets-react/streamline";
export function FlightDetailsFareUpgradeMobileUI(props) {
    const { header, title, content, headerWithIcon } = props;
    if (!title && !content)
        return null;
    return (React.createElement(Stack, { gap: 2 },
        header ? (React.createElement(FlightDetailsSectionTitleMobileUI, { title: header, asset: headerWithIcon ? { setName: "illustrations-traveller", assetName: "FlightsFareUpgrade" } : undefined })) : undefined,
        React.createElement(Card, null,
            React.createElement(Stack, { direction: "row", gap: 4 },
                React.createElement(IconWithBackground, { color: "action", backgroundColor: "action_alt", svg: StarUpIcon }),
                React.createElement(Stack.Item, { grow: true },
                    React.createElement(Stack, { gap: 0 },
                        title ? React.createElement(Text, { variant: "strong_2" }, title) : undefined,
                        content ? React.createElement(Text, { variant: "body_2" }, content) : undefined))))));
}
